function addUpsellToCart(thisButton) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var submitButton = thisButton;
    var form = document.querySelector('[id^="product-upsell-template-' + thisButton.dataset.formid + '--"]');
    if (document.querySelector('cart-drawer')) submitButton.setAttribute('aria-haspopup', 'dialog');

    if (submitButton.getAttribute('aria-disabled') === 'true') return;

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (thisButton.dataset.cartType != 'page') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                submitButton.setAttribute('aria-disabled', true);
                submitButton.querySelector('span').classList.add('hidden');
                return;
            }
            thisButton.error = false;
            cart.renderContents(response, true);
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            submitButton.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
            initSwiperPicto();
        });
}

function changeVariantEvent(thisVariant, event) {
    const formUpsellId = thisVariant.closest('.product-upsell-template').querySelector('#formUpsellId')
    formUpsellId.value = thisVariant.value;

    const currentOption = thisVariant.querySelector('option:checked');
    const img = formUpsellId.parentNode.querySelector('.cart-drawer-upsell_image-container img');
    const price = formUpsellId.parentNode.querySelector('.cart-drawer-upsell_price .price');
    const comparePrice = formUpsellId.parentNode.querySelector('.cart-drawer-upsell_price .compared');

    if (currentOption.dataset.img) {
        img.src = currentOption.dataset.img
    }

    if (currentOption.dataset.price) {
        price.innerHTML = currentOption.dataset.price
    }

    if (currentOption.dataset.comparePrice) {
        comparePrice.innerHTML = currentOption.dataset.comparePrice
    } else {
        comparePrice.innerHTML = ''
    }

    event.stopPropagation();
}